import {
  Scale, Briefcase, ListChecks, Brain, Users, GitBranch,
  LayoutDashboard, BarChart3, ShieldAlert, File, Facebook,
} from "lucide-react";

// Module -> icon + accent color classes (no purple, per design system)
export const MODULE_META = {
  governance: { Icon: Scale, color: "text-teal-300", chip: "border-teal-500/30 bg-teal-500/10 text-teal-200" },
  knowledge_business: { Icon: Briefcase, color: "text-blue-300", chip: "border-blue-500/30 bg-blue-500/10 text-blue-200" },
  tasks_workflow: { Icon: ListChecks, color: "text-sky-300", chip: "border-sky-500/30 bg-sky-500/10 text-sky-200" },
  memory_recall: { Icon: Brain, color: "text-cyan-300", chip: "border-cyan-500/30 bg-cyan-500/10 text-cyan-200" },
  ai_workforce: { Icon: Users, color: "text-emerald-300", chip: "border-emerald-500/30 bg-emerald-500/10 text-emerald-200" },
  change_control: { Icon: GitBranch, color: "text-indigo-300", chip: "border-indigo-500/30 bg-indigo-500/10 text-indigo-200" },
  dashboards: { Icon: LayoutDashboard, color: "text-amber-300", chip: "border-amber-500/30 bg-amber-500/10 text-amber-200" },
  analytics: { Icon: BarChart3, color: "text-sky-300", chip: "border-sky-500/30 bg-sky-500/10 text-sky-200" },
  system_capture_sensitive: { Icon: ShieldAlert, color: "text-rose-300", chip: "border-rose-500/30 bg-rose-500/10 text-rose-200" },
  social_memory: { Icon: Facebook, color: "text-blue-300", chip: "border-blue-500/30 bg-blue-500/10 text-blue-200" },
  general: { Icon: File, color: "text-slate-300", chip: "border-slate-500/30 bg-slate-500/10 text-slate-200" },
};

export function moduleMeta(key) {
  return MODULE_META[key] || MODULE_META.general;
}

export const CHART_COLORS = [
  "#2DD4BF", "#60A5FA", "#38BDF8", "#22C55E", "#F59E0B",
  "#818CF8", "#F43F5E", "#A3E635", "#2DD4BF", "#94A3B8",
];
